if (!customElements.get('ee-collection-nav')) customElements.define('ee-collection-nav', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController(); const signal = this.abort.signal;
    this.buttons = [...this.querySelectorAll('[data-teaser]')]; this.panels = [...this.querySelectorAll('[data-panel]')];
    this.currentLinks = [...this.querySelectorAll('[aria-current="page"]')];
    this.addEventListener('click', event => {
      const trigger = event.target.closest('[data-teaser]');
      if (trigger) { this.open(trigger.dataset.teaser, true); this.setHash(trigger.dataset.teaser); }
      if (event.target.closest('[data-return]')) { this.close(true); this.setHash(''); }
    }, { signal });
    this.addEventListener('keydown', event => { if (event.key === 'Escape' && this.active) { this.close(true); this.setHash(''); } }, { signal });
    window.addEventListener('hashchange', () => this.fromHash(), { signal });
    this.addEventListener('shopify:block:select', event => { const button = event.target.closest('[data-teaser]'); if (button) this.open(button.dataset.teaser, false); }, { signal });
    this.addEventListener('shopify:block:deselect', () => this.close(false), { signal });
    this.frame = requestAnimationFrame(() => this.fromHash());
  }
  setHash(id) { const url = new URL(location.href); url.hash = id ? `ee-coming-${id}` : ''; history.replaceState(null, '', url); }
  fromHash() { const id = location.hash.replace('#ee-coming-', ''); if (location.hash.startsWith('#ee-coming-') && this.buttons.some(b => b.dataset.teaser === id)) this.open(id, false); else this.close(false); }
  visibility(hidden) {
    this.hiddenTargets ??= new Map();
    const targets = [...document.querySelectorAll('collection-component.ee-product-grid'), ...[...document.querySelectorAll('[data-ee-editorial]')].map(el => el.closest('.shopify-section') || el)];
    targets.forEach(el => { if (hidden) { if (!this.hiddenTargets.has(el)) this.hiddenTargets.set(el, el.hidden); el.hidden = true; } else if (this.hiddenTargets.has(el)) { el.hidden = this.hiddenTargets.get(el); this.hiddenTargets.delete(el); } });
  }
  open(id, focus) {
    const panel = this.panels.find(p => p.dataset.panel === id); if (!panel) return;
    this.active = id; this.panels.forEach(p => { p.hidden = p !== panel; });
    this.buttons.forEach(b => b.setAttribute('aria-expanded', String(b.dataset.teaser === id)));
    this.currentLinks.forEach(a => a.removeAttribute('aria-current')); this.visibility(true);
    if (focus) panel.querySelector('h2')?.focus({ preventScroll: true });
  }
  close(focus) {
    const previous = this.active; this.active = null;
    this.panels?.forEach(p => { p.hidden = true; }); this.buttons?.forEach(b => b.setAttribute('aria-expanded', 'false'));
    this.currentLinks?.forEach(a => a.setAttribute('aria-current', 'page')); this.visibility(false);
    if (focus) this.buttons.find(b => b.dataset.teaser === previous)?.focus({ preventScroll: true });
  }
  disconnectedCallback() { this.close(false); this.abort?.abort(); cancelAnimationFrame(this.frame); }
});
